<div class="sample-shell">
  <div class="sample-shell__controls">
    @if (showControlForms()) {
      <ui-section>
        <ui-block width="4x">
          <ui-form
            [config]="menuControlFormConfig"
            [formValues]="menuControlFormValues"
            (formValuesDelta)="onMenuControlFormValuesChange($event)"
            (buttonClick)="onControlFormButtonClick($event)"
          ></ui-form>
        </ui-block>

        <ui-block width="2x">
          <ui-form
            [config]="columnControlFormConfig"
            [(formValues)]="columnControlFormValues"
            (formValuesChange)="onColumnControlFormValuesChange($event)"
            (buttonClick)="onControlFormButtonClick($event)"
          ></ui-form>
        </ui-block>
      </ui-section>
    }
  </div>

  <div class="sample-shell__status">
    <div class="status-card">
      <div class="status-card__title">Sample Status</div>
      <div class="status-card__body">{{ statusText() }}</div>
      <div class="status-card__note">
        This sample applies menu-setting changes by rebuilding the grid after you click
        <strong>Apply Menu Settings</strong>.
      </div>
    </div>

    <div class="status-card status-card--code">
      <div class="status-card__header">
        <div>
          <div class="status-card__title">Preset Config Preview</div>
          <div class="status-card__note">{{ presetDescription() }}</div>
        </div>

        <ui-button buttonText="Copy Config" (click)="onCopyConfigClick()"></ui-button>
      </div>

      <div class="code-container">
        <pre><code class="language-typescript" [textContent]="contextMenuConfigPreview()"></code></pre>
      </div>
    </div>
  </div>

  @if (showGrid()) {
    <ui-grid
      readEndpoint="mock/StarWarsActors"
      [columnDefs]="colDefs"
      [showPanelHeader]="true"
      [panelHeaderConfig]="panelHeaderConfig"
      [showStandardFilterControls]="true"
      [filterInputConfigs]="filterInputConfigs"
      [contextMenuConfig]="contextMenuConfig"
      [pageSizes]="[5, 10, 20]"
    ></ui-grid>
  }
</div>
